import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Checkbox,
  Space,
  Tabs,
  Radio,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  round2Decimals
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
import reportesDeCotizacionesPdf from "../../../../Pdf/reporteDeCotizacionesPdf";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteCotizaciones extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoClientes: null,
    todasClientes: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    objetoCanalesVenta: null,
    dataReporte: null,
    todasCotizaciones: [],
    dataGrafico: [],
    campoGrafico: "subtotal",
    subtotal: 0,
    totalImpuestos: 0,
    total: 0,
    totalRetenciones: 0,
    totalACobrar: 0,
    desglosarProductos: false,
    trazabilidadCotizaciones: false
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const campoGraficoGuardado = localStorage.getItem(`graficoCampo_ReporteCotizaciones_${this.props.empresaId}`);
    if (campoGraficoGuardado === "subtotal" || campoGraficoGuardado === "totalPagar") {
      this.setState({ campoGrafico: campoGraficoGuardado });
    }
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasClientes: res.data });
          this.setState({
            objetoClientes: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUsuarios: res.data });
          this.setState({
            objetoUsuarios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "canalesVenta/selectCanalesVenta",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            objetoCanalesVenta: (res.data.canalesVenta || []).map((value) => (
              <Option value={value._id} key={value._id}>
                {value.codigo + " - " + value.nombre}
              </Option>
            )),
          });
        } else {
          message.error("Ha sucedido un error y no se cargaron los canales de venta");
        }
      });
    this.consultarReporteCotizaciones({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      vendedores: 0,
      canalesVenta: 0,
      filtrarProyecto: 0,
      estadoCotizaciones: 5,
    });
  }

  async crearGrafico(valueCotizaciones, fechaInicial, fechaFinal, campoGrafico = this.state.campoGrafico) {
    let grafico = [];
    let graficoSumatoria = [];
    let sumatoria = 0;

    let fechaCambiante = moment(fechaInicial).locale("es");
    const fechaFinalMoment = moment(fechaFinal).locale("es");

    if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
      while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
        // eslint-disable-next-line no-loop-func
        const cotizaciones = valueCotizaciones.filter((todasCotizaciones) => {
          if (isNaN(todasCotizaciones.fechaCotizacion)) {
            return moment(fechaCambiante).isSame(
              moment(todasCotizaciones.fechaCotizacion, "DD/MM/YYYY"),
              "date"
            );
          } else {
            return false;
          }
        });

        let totalPagar = 0;

        cotizaciones.map((valueCotizacionDia) => {
          totalPagar += valueCotizacionDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
      }
    } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
      while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
        // eslint-disable-next-line no-loop-func
        const cotizaciones = valueCotizaciones.filter((todasCotizaciones) => {
          if (isNaN(todasCotizaciones.fechaCotizacion)) {
            return moment(fechaCambiante).isSame(
              moment(todasCotizaciones.fechaCotizacion, "DD/MM/YYYY"),
              "week"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;

        cotizaciones.map((valueCotizacionDia) => {
          totalPagar += valueCotizacionDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
      }
    } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
      while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
        // eslint-disable-next-line no-loop-func
        const cotizaciones = valueCotizaciones.filter((todasCotizaciones) => {
          if (isNaN(todasCotizaciones.fechaCotizacion)) {
            return moment(fechaCambiante).isSame(
              moment(todasCotizaciones.fechaCotizacion, "DD/MM/YYYY"),
              "month"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;

        cotizaciones.map((valueCotizacionDia) => {
          totalPagar += valueCotizacionDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
      }
    } else {
      while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
        // eslint-disable-next-line no-loop-func
        const cotizaciones = valueCotizaciones.filter((todasCotizaciones) => {
          if (isNaN(todasCotizaciones.fechaCotizacion)) {
            return moment(fechaCambiante).isSame(
              moment(todasCotizaciones.fechaCotizacion, "DD/MM/YYYY"),
              "year"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;

        cotizaciones.map((valueCotizacionDia) => {
          totalPagar += valueCotizacionDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "year").locale("es");
      }
    }

    await this.setState({
      dataGrafico: [
        {
          id: "Cotizaciones",
          color: "hsl(15, 70%, 50%)",
          data: grafico,
        },
        {
          id: "Cotizaciones Acumuladas",
          color: "hsl(15, 70%, 50%)",
          data: graficoSumatoria,
        },
      ],
    });
  }

  onChangeCampoGrafico = (campoGrafico) => {
    this.setState({ campoGrafico });
    localStorage.setItem(`graficoCampo_ReporteCotizaciones_${this.props.empresaId}`, campoGrafico);
    if (this.state.dataReporte) {
      this.crearGrafico(
        this.state.todasCotizaciones,
        this.state.dataReporte.fechaInicial,
        this.state.dataReporte.fechaFinal,
        campoGrafico
      );
    }
  };

  consultarReporteCotizaciones(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeVentas/reporteCotizaciones",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.crearGrafico(
            res.data.cotizaciones,
            res.data.fechaInicial,
            res.data.fechaFinal
          );
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasCotizaciones: res.data.cotizaciones,
            subtotal: res.data.subtotal,
            totalImpuestos: res.data.totalImpuestos,
            total: res.data.total,
            totalRetenciones: res.data.totalRetenciones,
            totalACobrar: res.data.totalACobrar,
            desglosarProductos: res.data.desglosarProductos,
            trazabilidadCotizaciones: res.data.trazabilidadCotizaciones,
          });
        } else if (res.data.success === 1) {
          message.error(res.data.message || "Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error(res.data.message || "Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const parseFecha = (val) => {
      if (!val) return val;
      const m = moment(val, "DD/MM/YYYY", true);
      return m.isValid() ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : val;
    };
    const columnasFecha = [
      "Fecha",
      "Fecha Creacion",
      "Fecha probable de pago",
      "Fecha Vigencia",
    ];
    let datosDescargar = []
    if (this.state.desglosarProductos) {
      for (const valueCotizacion of this.state.todasCotizaciones) {
        if (valueCotizacion.folio === '') {
          const cotizacion = this.state.todasCotizaciones.find(todasCotizaciones => todasCotizaciones.folio !== '' && todasCotizaciones._id.toString() === valueCotizacion._id.toString())
          datosDescargar.push({
            "Folio": cotizacion.folioCotizacion,
            "Serie": cotizacion.serieCotizacion,
            "Folio Venta": cotizacion.folioVenta,
            "Proyecto": valueCotizacion.proyecto || cotizacion.proyecto || "N/A",
            "Codigo Cliente": cotizacion.codigoCliente,
            "Clave Cliente": cotizacion.claveCliente,
            Fecha: parseFecha(cotizacion.fechaCotizacion),
            "Fecha Creacion": parseFecha(cotizacion.fechaCreacion),
            Cliente: cotizacion.cliente,
            "Razon social": cotizacion.razonSocial,
            "Codigo Insumo": valueCotizacion.codigoCliente,
            "Clave Insumo": valueCotizacion.claveCliente,
            "Cantidad": valueCotizacion.fechaCotizacion,
            "Descripcion": valueCotizacion.cliente,
            "Familia": valueCotizacion.familia,
            "Precio Unitario": valueCotizacion.total,
            "Descuento": valueCotizacion.descuento,
            "Subtotal Insumo": valueCotizacion.totalPagado,
            "Precio Con Impuestos": valueCotizacion.saldo,
            "Total Insumo": valueCotizacion.estado,
            "Fecha probable de pago": parseFecha(cotizacion.fechaPago),
            "Fecha Vigencia": parseFecha(cotizacion.fechaVigencia),
            SubTotal: cotizacion.subtotal,
            Impuestos: cotizacion.totalImpuestos,
            ...(this.state.trazabilidadCotizaciones && {
              Pedido: cotizacion.pedido,
              Venta: cotizacion.venta,
            }),
            "Retenciones": cotizacion.totalRetenciones,
            Total: cotizacion.total,
            "Total A Cobrar": cotizacion.totalPagar,
            Moneda: cotizacion.moneda,
            Estado: cotizacion.estado,
            Vendedor: cotizacion.vendedor,
            "Canal de Venta": cotizacion.canalVenta,
            ...(this.props.equipoMedico && {
              Paciente: cotizacion.paciente,
              Doctor: cotizacion.doctor,
              "Cirugía": cotizacion.cirugia,
            }),
          })
        }
      }
    } else {
      datosDescargar = this.state.todasCotizaciones.map((valueCotizacion) => {
        // const fechaHoy = moment();
        // let diasVencidos = "";

        // if (valueCotizacion.fechaVigencia) {
        //   const fechaVigencia = moment(valueCotizacion.fechaVigencia);
        //   if (fechaVigencia.isValid()) {
        //     let diff = fechaHoy.diff(fechaVigencia, "days");
        //     diasVencidos = diff > 0 ? diff : 0; // solo positivos
        //   } else {
        //     diasVencidos = ""; // si la fecha no es válida
        //   }
        // }
        let impuestosAgregar = {}
        if (Array.isArray(valueCotizacion.arrayImpuestos)) {
          valueCotizacion.arrayImpuestos.forEach(impuesto => {
            impuestosAgregar[impuesto.descripcionFactura] = round2Decimals(impuesto.totalImpuestos)
          });
        }
        return {
          "Folio": valueCotizacion.folioCotizacion,
          "Serie": valueCotizacion.serieCotizacion,
          "Folio Venta": valueCotizacion.folioVenta,
          "Proyecto": valueCotizacion.proyecto || "N/A",
          "Codigo Cliente": valueCotizacion.codigoCliente,
          "Clave Cliente": valueCotizacion.claveCliente,
          Fecha: parseFecha(valueCotizacion.fechaCotizacion),
          "Fecha Creacion": parseFecha(valueCotizacion.fechaCreacion),
          Cliente: valueCotizacion.cliente,
          "Razon social": valueCotizacion.razonSocial,
          "Fecha Vigencia": parseFecha(valueCotizacion.fechaVigencia),
          SubTotal: valueCotizacion.subtotal,
          Impuestos: valueCotizacion.totalImpuestos,
          "Retenciones": valueCotizacion.totalRetenciones,
          Total: valueCotizacion.total,
          "Total A Cobrar": valueCotizacion.totalPagar,
          Moneda: valueCotizacion.moneda,
          Estado: valueCotizacion.estado,
          Vendedor: valueCotizacion.vendedor,
          "Canal de Venta": valueCotizacion.canalVenta,
          ...(this.state.trazabilidadCotizaciones && {
            Pedido: valueCotizacion.pedido,
            Venta: valueCotizacion.venta,
          }),
          ...(this.props.equipoMedico && {
            Paciente: valueCotizacion.paciente,
            Doctor: valueCotizacion.doctor,
            "Cirugía": valueCotizacion.cirugia,
          }),
          ...impuestosAgregar,
        };
      });
    }
    const worksheet = XLSX.utils.json_to_sheet(datosDescargar, { cellDates: true });
    if (worksheet["!ref"]) {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const indicesFecha = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        const header = worksheet[XLSX.utils.encode_cell({ r: range.s.r, c: C })];
        if (header && columnasFecha.includes(header.v)) {
          indicesFecha.push(C);
        }
      }
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        for (const C of indicesFecha) {
          const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && cell.v instanceof Date) {
            cell.t = "d";
            cell.z = "dd/mm/yyyy";
          }
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Cotizaciones");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, `Reporte_De_Cotizaciones_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reportesDeCotizacionesPdf(this.state.dataReporte))
      .download(`Reporte_De_Cotizaciones_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        sorter: (a, b) => {
          if (a.folio < b.folio) {
            return -1;
          }
          if (a.folio > b.folio) {
            return 1;
          }
          return 0;
        },
        buscar: "folio",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaCotizacion",
        key: "fechaCotizacion",
        sorter: (a, b) => {
          if (moment(a.fechaCotizacion, "DD/MM/YYYY") < moment(b.fechaCotizacion, "DD/MM/YYYY")) {
            return -1;
          }
          if (moment(a.fechaCotizacion, "DD/MM/YYYY") > moment(b.fechaCotizacion, "DD/MM/YYYY")) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaCotizacion",
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        sorter: (a, b) => {
          if (a.cliente < b.cliente) {
            return -1;
          }
          if (a.cliente > b.cliente) {
            return 1;
          }
          return 0;
        },
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Vigencia",
        dataIndex: "fechaVigencia",
        key: "fechaVigencia",
        sorter: (a, b) => {
          if (moment(a.fechaVigencia, "DD/MM/YYYY") < moment(b.fechaVigencia, "DD/MM/YYYY")) {
            return -1;
          }
          if (moment(a.fechaVigencia, "DD/MM/YYYY") > moment(b.fechaVigencia, "DD/MM/YYYY")) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaVigencia",
        ellipsis: true,
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: "totalPagar",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => {
          if (a.estado < b.estado) {
            return -1;
          }
          if (a.estado > b.estado) {
            return 1;
          }
          return 0;
        },
        buscar: "estado",
        ellipsis: true,
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        sorter: (a, b) => {
          if (a.vendedor < b.vendedor) {
            return -1;
          }
          if (a.vendedor > b.vendedor) {
            return 1;
          }
          return 0;
        },
        buscar: "vendedor",
        ellipsis: true,
      },
      {
        title: "Canal de Venta",
        dataIndex: "canalVenta",
        key: "canalVenta",
        sorter: (a, b) => {
          if ((a.canalVenta || "") < (b.canalVenta || "")) return -1;
          if ((a.canalVenta || "") > (b.canalVenta || "")) return 1;
          return 0;
        },
        buscar: "canalVenta",
        ellipsis: true,
      },
      ...(this.props.equipoMedico
        ? [
            {
              title: "Paciente",
              dataIndex: "paciente",
              key: "paciente",
              sorter: (a, b) => {
                if ((a.paciente || "") < (b.paciente || "")) return -1;
                if ((a.paciente || "") > (b.paciente || "")) return 1;
                return 0;
              },
              buscar: "paciente",
              ellipsis: true,
            },
            {
              title: "Doctor",
              dataIndex: "doctor",
              key: "doctor",
              sorter: (a, b) => {
                if ((a.doctor || "") < (b.doctor || "")) return -1;
                if ((a.doctor || "") > (b.doctor || "")) return 1;
                return 0;
              },
              buscar: "doctor",
              ellipsis: true,
            },
            {
              title: "Cirugía",
              dataIndex: "cirugia",
              key: "cirugia",
              sorter: (a, b) => {
                if ((a.cirugia || "") < (b.cirugia || "")) return -1;
                if ((a.cirugia || "") > (b.cirugia || "")) return 1;
                return 0;
              },
              buscar: "cirugia",
              ellipsis: true,
            },
          ]
        : []),
    ];
    return (
      <>
        <Form
          ref={this.formRef}
          name="agregarUsuario"
          onFinish={this.consultarReporteCotizaciones.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Cotizaciones"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Clientes"
                    >
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Vendedores"
                    >
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem
                        label="Estado"
                        name="estadoCotizaciones"
                        required
                        initialValue={5}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={5}>
                            Todos
                          </Option>
                          <Option value={4}>Pedido</Option>
                          <Option value={3}>Venta</Option>
                          <Option value={2}>Pendiente</Option>
                          <Option value={1}>Vigente</Option>
                          <Option value={7}>Vencido</Option>
                          <Option value={0}>Cancelados</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Desglosar Productos"
                        name="desglosarProductos"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Trazabilidad de Cotizaciones"
                        name="trazabilidadCotizaciones"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                      {/* <FormItem
                        label="Detalle"
                        name="detalle"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem> */}
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="6" key="6" forceRender tab="Canales de Venta">
                  <FormItem name="canalesVenta" margin noStyle>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Canales de Venta"
                    >
                      {this.state.objetoCanalesVenta}
                    </SelectItem>
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
                <h1 style={{ fontSize: 18, margin: 0 }}>Gráfico</h1>
                <Radio.Group
                  size="small"
                  value={this.state.campoGrafico}
                  onChange={(e) => this.onChangeCampoGrafico(e.target.value)}
                >
                  <Radio.Button value="subtotal">Subtotal</Radio.Button>
                  <Radio.Button value="totalPagar">Total a Pagar</Radio.Button>
                </Radio.Group>
              </div>

              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                enableSlices="x"
                useMesh={true}

                yFormat={(e) => dineroDisabledMask(Math.abs(e))}

                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}

                curve="monotoneX"
                lineWidth={2}

                // ✅ Menos ruido visual
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}

                // Si quieres aún más limpio, descomenta:
                // enablePoints={false}

                colors={["#06B6D4", "#EC4899"]}
                colorBy="index"

                axisTop={null}
                axisRight={null}

                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  // ✅ muestra menos etiquetas (una de cada 2 o 3)
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map(d => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}

                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}

                // ✅ Grid más limpio
                enableGridX={false}

                legends={[
                  {
                    anchor: "top-right",
                    direction: "column",
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 130,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
              />
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Subtotal</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.subtotal)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>+</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Impuestos</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalImpuestos)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.total)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>-</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Retenciones</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalRetenciones)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Cobrar</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalACobrar)}
                  </h1>
                </Col>
              </Row>
            </div>
            <TableItem
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: (event) => {
                    this.props.history.push("/panel/verCotizacion", {
                      id: record._id,
                    });
                  },
                };
              }}
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasCotizaciones}
              size="small"
              pagination={false}
            />
            {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
          {this.state.pdf && (
            <iframe
              title={"documentos"}
              style={{ width: "100%", height: "100vh" }}
              id="printPdf"
              name="printPdf"
            />
          )}
        </div> */}
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    equipoMedico: state.empresa.equipoMedico,
  };
};

export default connect(mapStateToProps)(ReporteCotizaciones);
